import { Grid, Paper } from "@mui/material";
import CreditCardIcon from '@mui/icons-material/CreditCard';
import Button from "../UI/Button";

const UsuarioCartaoCreditoList = ({ listUsuarioCartaoCredito }) => {
    return (
        <Grid container spacing={3} component={Paper}>
            {listUsuarioCartaoCredito.map((usuarioCartaoCredito) => (
                <Grid size={12}>
                    <Grid container direction="row" spacing={3}>
                        <Grid size={3}>
                            <CreditCardIcon />
                        </Grid>
                        <Grid size={6}>
                            <p>Terminado em {usuarioCartaoCredito.terminoCartao}</p>
                            <p>Vencimento {usuarioCartaoCredito.vencimento}</p>
                        </Grid>
                        <Grid size={3}>
                            <Button>Excluir</Button>
                        </Grid>
                    </Grid>
                </Grid  >
            ))}
        </Grid>
    );
}

export default UsuarioCartaoCreditoList;